// extracted by mini-css-extract-plugin
module.exports = {"barContent":"TaskBar_barContent_1DSVB","section":"TaskBar_section_k2kSB","sectionLeft":"TaskBar_sectionLeft_1mHLj","sectionButton":"TaskBar_sectionButton_3OZod"};